// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const chart = "HeadedChartLayout__chart__7egdA";
export const chartWrapper = "HeadedChartLayout__chartWrapper__8vcVM";
export const fullHeight = "HeadedChartLayout__fullHeight__b6Lh6";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const headedChartLayout = "HeadedChartLayout__headedChartLayout__FyJnC";
export const header = "HeadedChartLayout__header__A5-qv";
export const isMobile = "HeadedChartLayout__isMobile__jy0ue";
export const legend = "HeadedChartLayout__legend__UrjhW";
export const medium = "500";
export const preloader = "HeadedChartLayout__preloader__jrcIS";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";